/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "local 0.1.0",
    versionChannel: "local",
    buildDate: "2025-12-06T20:26:14.958Z",
    commitHash: "39e1f55640b58bf8d3704421f28bfbe5af6b08f7",
};
